/**
 * useObjectUrl — a `blob:` URL for a file or blob while the component shows it, revoked when it changes or unmounts (an
 * attached image's preview). Created in an effect: a URL made during render would leak on every render.
 */
import { useEffect, useState } from 'react';

export function useObjectUrl(source: Blob | null | undefined): string | null {
  const [url, setUrl] = useState<string | null>(null);
  useEffect(() => {
    if (!source) {
      setUrl(null);
      return;
    }
    const next = URL.createObjectURL(source);
    setUrl(next);
    return () => URL.revokeObjectURL(next);
  }, [source]);
  return url;
}
